export const ORGANIZATIONS_TABLE_DATA_INDICES = {
	INSTANCE_URL: 'instanceUrl',
	IS_SANDBOX: 'isSandbox',
	NAME: 'name',
	SALESFORCE_USERNAME: 'salesforceUsername'
};
